var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconController = function SvgIconController(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M4.423 20.5q-.757 0-1.282-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T4.423 3.5h13.385q.758 0 1.282.525.526.525.526 1.283v2.077h1.769v1.5h-1.77v2.365h1.77v1.5h-1.77v2.366h1.77v1.5h-1.77v2.076q0 .758-.524 1.283-.525.525-1.283.525zm0-1.5h13.385a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H4.423a.3.3 0 0 0-.211.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .211.096M6.5 16.615h4.52v-3.519H6.5zm5.712-6.711h3.519v-2.52h-3.52zm-5.712 2h4.52v-4.52H6.5zm5.712 4.711h3.519v-5.519h-3.52z"
  })));
};
export default SvgIconController;